namespace GpScot.PageClassSetter {
	export function init() {

		const additionalBodyClasses =
			document.querySelector('#dtCampaign') ?
				'nhssf-campaign-page' :
				document.querySelector('#search-body') ?
					'nhssf-search-page' : '';

		if (additionalBodyClasses) {
			document.querySelector('body').classList.add(additionalBodyClasses);
		}
		
		const isHomePage = window.location.pathname === '/';

		const mainCssClass = isHomePage && !document.querySelector('.error-panel') ?
			['nhsuk-homepage', 'nhsuk-main-wrapper--no-padding'] :
			['nhsuk-main-wrapper--inform-content-wrapper'];

		document.querySelector('main').classList.add(...mainCssClass);
	}
}